import React from 'react'

const ICONS = {
  'circle-amber': (
    <circle cx="7" cy="7" r="7" fill="#FFB400" />
  ),
  'triangle-amber': (
    <path d="M0 0 H14 V14 Z" fill="#FFB400" />
  ),
  'pill-green': (
    <rect x="2" y="2" width="10" height="10" rx="5" fill="#34C77B" />
  ),
  'diamond-purple': (
    <rect x="2" y="2" width="10" height="10" transform="rotate(45 7 7)" fill="#7B2D8E" />
  ),
  'diamond-cyan': (
    <path d="M7 0 L14 7 L7 14 L0 7 Z" fill="#3DBBE0" />
  ),
  'circle-orange': (
    <circle cx="7" cy="7" r="7" fill="#FF6B35" />
  ),
  'triangle-cyan': (
    <path d="M7 0 L14 14 H0 Z" fill="#3DBBE0" />
  ),
  'square-red': (
    <rect width="14" height="14" fill="#E1182D" />
  ),
}

const CategoryIcon = ({ type }) => (
  <svg width={14} height={14} viewBox="0 0 14 14" aria-hidden="true">
    {ICONS[type] || ICONS['circle-amber']}
  </svg>
)

const EnterpriseAIUseCaseCard = ({ card }) => (
  <article className="enterprise-ai-use-cases__card">
    <div className="enterprise-ai-use-cases__card-top">
      <span className="enterprise-ai-use-cases__category">
        <CategoryIcon type={card.icon} />
        <span>{card.category}</span>
      </span>
      <span className="enterprise-ai-use-cases__badge">{card.badge}</span>
    </div>
    <h3 className="enterprise-ai-use-cases__card-title">{card.title}</h3>
    <p className="enterprise-ai-use-cases__kpi">
      <svg width="15" height="12" viewBox="0 0 15 12" fill="none" aria-hidden="true">
        <path d="M1 6.5 L5 10.5 L14 1" stroke="#fff" strokeWidth="2" />
      </svg>
      <span>{card.kpi}</span>
    </p>
    <p className="enterprise-ai-use-cases__card-body">{card.description}</p>
  </article>
)

export default EnterpriseAIUseCaseCard
